module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin21.c27d5a4.woff2";